import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const Terms = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 container mx-auto px-4 py-16">
        <h1 className="text-3xl font-bold mb-8">Terms of Service</h1>
        
        <div className="prose prose-gray max-w-none space-y-6">
          <section>
            <h2 className="text-xl font-semibold mb-3">Acceptance of Terms</h2>
            <p className="text-muted-foreground">
              By accessing and using NoteGenius, you agree to be bound by these Terms of Service. 
              If you do not agree to these terms, please do not use our services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Use of Service</h2>
            <p className="text-muted-foreground">
              NoteGenius provides AI-powered note processing services for educational purposes. 
              You agree to use the service only for lawful purposes and in accordance with these terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">User Content</h2>
            <p className="text-muted-foreground">
              You retain ownership of the content you upload. By uploading content, you grant us 
              a license to process it for the purpose of providing our services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Limitations</h2>
            <p className="text-muted-foreground">
              We are not responsible for any errors in AI-generated content. Always verify important 
              information independently. Service availability may vary.
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Terms;
